export const urlRegex =
  /^((https?):\/\/)+(www\.)?((?!www\.)[a-z0-9-])+(\.[a-z]{2,15})+\/?/;
export const noNumeric = /^([^0-9]*)$/;
export const numeric = /^([0-9]*)$/;
